import { Capacitor } from '@capacitor/core';

export const isNativeApp = Capacitor.isNativePlatform();

/**
 * Download a blob to the device's Downloads folder on Android,
 * or fall back to standard browser download on web.
 */
export async function downloadFile(blob, filename) {
  if (!isNativeApp) {
    return webDownload(blob, filename);
  }

  // Try native Filesystem first, fall back to web download
  try {
    const { Filesystem, Directory } = await import('@capacitor/filesystem');
    const base64 = await blobToBase64(blob);
    const result = await Filesystem.writeFile({
      path: filename,
      data: base64,
      directory: Directory.Documents,
      recursive: true,
    });
    return { success: true, uri: result.uri, method: 'native' };
  } catch (e) {
    // Filesystem plugin unavailable or failed — fall back to web download
    console.warn('Native download failed, using web fallback:', e.message);
    return webDownload(blob, filename);
  }
}

function webDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return { success: true, method: 'web' };
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

